import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MessageSquare } from "lucide-react";

export const TextPreview = ({ opening }) => {
  const [samples, setSamples] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/admin/sms/scripts/preview", { opening }).then((r) => setSamples(r.data.samples)).catch(() => setSamples([]));
    }, 500);
    return () => clearTimeout(t);
  }, [opening]);
  if (!samples) return null;
  return (
    <div className="mt-3 rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="text-preview">
      <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
        <MessageSquare className="h-3.5 w-3.5" />Preview with your real leads
      </div>
      {!samples.length && <p className="text-sm text-slate-500" data-testid="text-preview-empty">Add a lead with a phone number to see a preview.</p>}
      <div className="grid gap-3 md:grid-cols-2">
        {samples.map((s, i) => (
          <div key={i} data-testid={`text-preview-sample-${i}`}>
            <div className="mb-1 text-xs text-slate-500">{s.source} · {s.lead_name} · {s.lead_type}</div>
            <div className="max-w-md whitespace-pre-wrap rounded-2xl rounded-bl-sm bg-white px-4 py-2.5 text-sm text-slate-800 shadow-sm ring-1 ring-slate-200">{s.text}</div>
            <div className="mt-1 text-[11px] text-slate-400">{s.text.length} characters</div>
          </div>
        ))}
      </div>
    </div>
  );
};
